import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription, catchError, mergeMap, of, retryWhen, throwError } from 'rxjs';
import { AreaIndexedDBService } from 'src/app/indexDB/area.service';
import { AreasService } from 'src/app/pages/settings/services/areas.service';

@Component({
  selector: 'app-area-search-select',
  templateUrl: './area-search-select.component.html',
  styleUrls: ['./area-search-select.component.css']
})
export class AreaSearchSelectComponent implements OnInit, OnDestroy  {

  @Input() showDefaultListValue:boolean = true;
  @Input() showNoneOption: boolean = false;
  @Input() defaultLabel: string = 'All';
  @Input() defaultSelected:any;
  @Input() control: FormControl | string;
  @Input() disabled: boolean = false
  @Input() type: 'client' | 'server' = 'client';
  @Output() emitSelectedVal: EventEmitter<any> = new EventEmitter();

  public areaLabel: string = $localize`:@@area:Area`;
  public areasData: { id: number, name: string }[] = [];
  public endpoint: string = '';
  public storedArrayString = localStorage.getItem('indexDBFetched');
  public storedArray = this.storedArrayString ? JSON.parse(this.storedArrayString) : [];
  private subscription: Subscription;

  constructor(
    private areaIDBService: AreaIndexedDBService,
    private areaService: AreasService
  ) { }

  ngOnInit(): void {
    this.getAllAreas();
    this.endpoint = this.areaService.searchAreaEndpoint;
    if (!this.storedArray.includes('areaList')) {
      this.type = 'server';
    }
  }

  emitSelected(value:{id:any, name:string}) {
    this.emitSelectedVal.emit(value);
  }

  getAllAreas(retryCount = 0) {
    if (this.subscription) this.subscription.unsubscribe();
    this.subscription = this.areaIDBService.getStoredData().subscribe({
      next: (areas) => {
        this.areasData = areas;
        if (areas.length === 0 && retryCount < 10) {
          setTimeout(() => this.getAllAreas(retryCount + 1), 300);
        }
      },
      error: (error) => {}
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
